<ng-container *ngIf="disableSelection || !selectedCountry; else selectionEnabled">
  <div>
    {{ selectedCountry ?? null | country | async }}
  </div>
</ng-container>
<ng-template #selectionEnabled>
  <yat-resizing-select id="8495d95c-943e-4f53-b0b1-61d30626b714" [formControl]="countryControl" [items]="sortedCountries">
    <ng-template let-item>
      {{ item | country | async }}
    </ng-template>
  </yat-resizing-select>
</ng-template>
